import * as React from "react";
import { useChartGroupContext } from "./useChartGroupContext";
/**
 * Defines a panel without own chart: defines it in the surrounding chart group and
 * draws its series in the target panel `mergeInto`, independent of the ChartsFrameContainer
 * it lives in. Renders nothing; `timeSeriesData` should be a stable reference.
 */
export const MergePanel = ({ id, mergeInto, order, timeSeriesData, }) => {
    const { defineMergePanel } = useChartGroupContext();
    React.useEffect(() => {
        return defineMergePanel({ id, mergeInto, order, timeSeriesData });
    }, [id, mergeInto, order, timeSeriesData, defineMergePanel]);
    return null;
};
//# sourceMappingURL=MergePanel.js.map